import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { isAuthenticated } from "../auth";
 
const BreadcrumbImage = () => {

  const [loggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
      const checkAuthStatus = () => {
        const authStatus = isAuthenticated();
        setLoggedIn(authStatus);
      };
  
      // Check authentication status on mount
      checkAuthStatus();
  
      // Set an interval to check authentication status every second
      const intervalId = setInterval(checkAuthStatus, 1000); // Adjust the interval as needed
  
      // Cleanup the interval on component unmount
      return () => clearInterval(intervalId);
    }, [loggedIn]); // Run only on mount
  

  return (
    <section
      className='banner-inner z-1 position-relative py-72'
      style={{
        backgroundColor: '#c94a10',
      }}
    >
      <div className='container'>
        <div className='banner-inner__content text-center'>
          <h4 className='text-white mb-20 fw-semibold'>
            Start Your Dropshipping Business Today
          </h4>
          <p className='text-white my-20'>
            Join thousands of entrepreneurs building profitable e-commerce businesses with zero inventory risk. Access products from Amazon, AliExpress, Alibaba, Walmart, and eBay.
          </p>
          

          
                               {loggedIn ? (
                               
                         <></>
                               ) : (
                                <Link to='/account' className='btn btn-main rounded-8'>
                                  Create An Account
                                </Link>
                               )}
        </div>
      </div>
    </section>
  );
};

export default BreadcrumbImage;
